import React, { useContext, useMemo } from 'react';

import { UserDataContext } from 'lane-shared/contexts';
import { BEPrismTokenProvider } from 'lane-shared/contexts/BuildingEnginesPrism/useBEPrismTokenContext';

import { convertToUUID } from 'uuid-encoding';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';
import { Building } from 'lane-shared/helpers/integrations/BuildingEnginesPrism/client/buildings';
import VisitForm from 'components/integrations/BuildingEnginesPrismVisitors/components/VisitForm';

export default function VisitEdit({
  params,
  content,
  buildingId: selectedBuildingId,
  buildings,
}: {
  params: { id: string; visitId: string; visitorId: string };
  content: any;
  buildingId?: string;
  buildings?: Building[];
}) {
  const { user } = useContext(UserDataContext);
  const isBEFFEnabled = useFlag(
    FeatureFlag.EnableSSOAndMultiBuildingForBE,
    false
  );
  const buildingId = isBEFFEnabled 
    ? selectedBuildingId 
    : content?.integration?.settings?.buildingId;

  const tokenRequest = useMemo(() => {
    return {
      channelIntegrationId: content?.integration?._id
        ? convertToUUID(content?.integration?._id)
        : '',
      tenantData: {
        tenant_email: user?.profile?.email || '',
        tenant_account_id:
          content?.integration?.settings?.tenantAccountId || '',
      },
    };
  }, [
    content?.integration?._id,
    user?.profile?.email,
    content?.integration?.settings?.tenantAccountId,
  ]);

  return (
    <BEPrismTokenProvider tokenRequest={tokenRequest}>
      <VisitForm
        content={content}
        interaction={{ visitId: params.visitId, visitorId: params.visitorId }}
        {...(isBEFFEnabled && { buildingId, buildings })}
      />
    </BEPrismTokenProvider>
  );
}
